<mat-form-field appearance="fill" style="margin-top: -23px;"  [ngStyle]="disablePointerEvent === true && {
    'pointer-events':'none'}" >    
    <span matSuffix *ngIf="isCellValue" (click)="clearText()"><i  class="fas fa-times"></i></span>
    <input class="customFont" type="text" [(ngModel)]="cellValue" 
(keypress)="onCellEdit($event)" (change)="updateCellValue()" matInput/>
</mat-form-field>